import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Profile } from 'src/app/data/models/interfaces/profile.interface';
import { ContractedFeatureUtil } from 'src/app/data/utils/contracted-feature.utils';

@Component({
  templateUrl: './help-user-profiles-dialog.component.html',
  styleUrls: ['./help-user-profiles-dialog.component.scss'],
})
export class HelpUserProfilesDialogComponent implements OnInit {
  profileFeatures: { name: string; features: string[] }[] = [];

  featuresToShow: string[] | undefined = [];

  constructor(
    public dialogRef: MatDialogRef<HelpUserProfilesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public profile: Profile,
    private contractedFeatureUtil: ContractedFeatureUtil
  ) { }

  DiretorFeatures() {
    let features = [
      'Criação e edição de notícias',
      'Criação e edição de eventos',
      'Criação e edição dos canais de atendimento',
      'Acesso ao chat com todos os responsáveis nos canais que ele estiver alocado',
      'Acesso chat privado com todos os responsáveis',
      'Criação e edição dos usuários do sistema',
      'Criação e edição de atalhos',
    ];
    if (this.contractedFeatureUtil.hasCheguei()) {
      features.push('Criação, edição e monitoramento de portarias no Cheguei');
    }
    this.profileFeatures.push({
      name: 'Diretor',
      features,
    });
  }

  CoordenadorFeatures() {
    let features = [
      'Criação e edição de notícias',
      'Criação e edição de eventos',
      'Acesso ao chat com todos os responsáveis nos canais que ele estiver alocado',
      'Acesso ao chat privado com todos os responsáveis',
      'Criação e edição dos usuários do sistema',
      'Criação e edição de atalhos',
    ];
    if (this.contractedFeatureUtil.hasCheguei()) {
      features.push('Criação, edição e monitoramento de portarias no Cheguei');
    }
    this.profileFeatures.push({
      name: 'Coordenador',
      features,
    });
  }

  ProfessorFeatures() {
    let features = [
      'Acesso ao chat com todos os responsáveis nos canais que ele estiver alocado',
      'Acesso ao chat privado com todos os responsáveis',
    ];
    this.profileFeatures.push({
      name: 'Professor',
      features,
    });
  }

  RespFinanceiroFeatures() {
    let features = [
      'Acesso às notícias direcionadas para esse perfil',
      'Acesso aos eventos direcionados para esse perfil',
      'Acesso ao chat somente com os canais do colégio',
      'Acesso aos atalhos direcionados para esse perfil',
    ];
    this.profileFeatures.push({
      name: 'Responsável financeiro',
      features,
    });
  }

  RespPedagogicoFeatures() {
    let features = [
      'Acesso às notícias direcionadas para esse perfil',
      'Acesso aos eventos direcionados para esse perfil',
      'Acesso ao chat somente com os canais do colégio',
      'Acesso aos atalhos direcionados para esse perfil',
    ];
    if (this.contractedFeatureUtil.hasCheguei()) {
      features.push('Acesso ao Cheguei');
    }
    this.profileFeatures.push({
      name: 'Responsável pedagógico',
      features,
    });
  }

  RespFinanceiroPedagogicoFeatures() {
    let features = [
      'Acesso às notícias direcionadas para esse perfil',
      'Acesso aos eventos direcionados para esse perfil',
      'Acesso ao chat somente com os canais do colégio',
      'Acesso aos atalhos direcionados para esse perfil',
    ];
    if (this.contractedFeatureUtil.hasCheguei()) {
      features.push('Acesso ao Cheguei');
    }
    this.profileFeatures.push({
      name: 'Responsável financeiro e pedagógico',
      features,
    });
  }

  AlunoFeatures() {
    let features = [
      'Acesso às notícias direcionadas para esse perfil',
      'Acesso aos eventos direcionados para esse perfil',
      'Acesso ao chat somente com os canais do colégio',
      'Acesso aos atalhos direcionados para esse perfil',
    ];
    this.profileFeatures.push({
      name: 'Aluno',
      features,
    });
  }

  FuncionarioFeatures() {
    let features = [
      'Acesso ao chat com todos os responsáveis nos canais que ele estiver alocado',
      'Acesso chat privado com todos os responsáveis',
      'Acesso aos usuários do sistema',
    ];
    if (this.contractedFeatureUtil.hasCheguei()) {
      features.push('Criação, edição e monitoramento de portarias no Cheguei');
    }
    this.profileFeatures.push({
      name: 'Funcionário',
      features,
    });
  }

  AssessorFeatures() {
    let features = [
      'Criação e edição de notícias',
      'Criação e edição de eventos',
      'Acesso ao chat com todos os responsáveis nos canais que ele estiver alocado',
      'Acesso ao chat privado com todos os responsáveis',
    ];
    if (this.contractedFeatureUtil.hasCheguei()) {
      features.push('Monitoramento de portarias no Cheguei');
    }
    this.profileFeatures.push({
      name: 'Assessor',
      features,
    });
  }

  ngOnInit(): void {
    this.DiretorFeatures();
    this.CoordenadorFeatures();
    this.ProfessorFeatures();
    this.RespFinanceiroFeatures();
    this.RespPedagogicoFeatures();
    this.RespFinanceiroPedagogicoFeatures();
    this.AlunoFeatures();
    this.FuncionarioFeatures();
    this.AssessorFeatures();

    this.featuresToShow = this.profileFeatures.find(
      (pf) => pf.name === this.profile.name
    )?.features;
  }

  onClick() {
    this.dialogRef.close();
  }
}
